import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Input, Tooltip } from 'antd';
import { SkinTwoTone } from '@ant-design/icons';
import { filter } from 'lodash';

import {
    loadUsers,
    setSelectedUser
} from '../actions';
import * as selectors from '../selectors';
import * as constants from '../constants';

import uistate from '../../uistate';
import common from '../../../common';

class UsersTable extends Component {

    UNSAFE_componentWillMount() {
        this.props.loadUsers();
    }

    state = {
        filteredInfo: null,
        sortedInfo: null,
        filtertext: '',
        selectedRowKeys: [],
    };

    setFilterText = (txt) => {
        this.setState({
            filtertext: txt.toLowerCase(),
        });
    }
    handleChange = (pagination, filters, sorter) => {
        //console.log('Various parameters', sorter); 
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
        });
    }
    setSelectedUser = (id, path) => {
        this.props.setSelectedUser(id);
        this.props.history.push(path);
    }
    selectRow = (record) => {
        let selectedRowKeys = [];
        selectedRowKeys.push(record.idUser);
        this.setState({ selectedRowKeys });
        if (this.props.onSelect) {
            this.props.onSelect(record.idUser);
        }
    }
    onSelectedRowKeysChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
        if (this.props.onSelect) {
            this.props.onSelect(selectedRowKeys[0]);
        }
    }
    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'UsersTable', key);
    }

    render() {
        let { sortedInfo, filteredInfo, filtertext, selectedRowKeys } = this.state;
        sortedInfo = sortedInfo || {};
        filteredInfo = filteredInfo || {};
        const pagesize = this.props.pagesize || 20;

        let columns = [{
            title: this.label("Type"),
            dataIndex: 'userTypeId',
            key: 'userTypeId',
            sorter: (a, b) => ('' + a.userTypeId).localeCompare(b.userTypeId),
            sortOrder: sortedInfo.columnKey === 'userTypeId' && sortedInfo.order,
            render: (userTypeId) => {
                let color = 'red';
                switch (userTypeId) {
                    case 1:
                        color = '#0091dc'
                        break;
                    default:
                        break;
                }
                return (
                    <Tooltip placement="topLeft" title={this.label(userTypeId.toString())}>
                        <SkinTwoTone twoToneColor={color} />
                    </Tooltip>
                )
            },
        }, {
            title: this.label("FirstName"),
            dataIndex: 'firstname',
            key: 'firstname',
            sorter: (a, b) => ('' + a.firstname).localeCompare(b.firstname),
            sortOrder: sortedInfo.columnKey === 'firstname' && sortedInfo.order,
        },{
            title: this.label("Name"),
            dataIndex: 'displayname',
            key: 'displayname',
            sorter: (a, b) => ('' + a.displayname).localeCompare(b.displayname),
            sortOrder: sortedInfo.columnKey === 'displayname' && sortedInfo.order,
        }, {
            title: this.label("Company"),
            dataIndex: 'company',
            key: 'company',
            sorter: (a, b) => ('' + a.company).localeCompare(b.company),
            sortOrder: sortedInfo.columnKey === 'company' && sortedInfo.order,
        }, {
            title: this.label("JobDesc"),
            dataIndex: 'jobdescription',
            key: 'jobdescription',
            sorter: (a, b) => ('' + a.jobdescription).localeCompare(b.jobdescription),
            sortOrder: sortedInfo.columnKey === 'jobdescription' && sortedInfo.order,
        }];

        let rowSelection = null;
        if (this.props.onSelect) {
            rowSelection = {
                selectedRowKeys,
                type: 'radio',
                onChange: this.onSelectedRowKeysChange,
            };
        }

        const filteredUsers = filter(this.props.allusers, function (o) {
            return o.displayname.toLowerCase().includes(filtertext) || o.sAMAccountName.toLowerCase().includes(filtertext) || o.firstname.toLowerCase().includes(filtertext);
        });
        return (
            <div>
                <Input.Search
                    placeholder={this.label("SearchText")}
                    onSearch={value => this.setFilterText(value)}
                    style={{ width: 300, marginLeft: 0, marginTop: 0, marginBottom: 10 }} />
                <br />
                <Table size='small' columns={columns} dataSource={filteredUsers} onChange={this.handleChange}
                    rowSelection={rowSelection}
                    rowKey={record => record.idUser} pagination={{ pageSize: pagesize }}
                    onRow={(record) => ({
                        onClick: () => {
                            this.selectRow(record);
                        },
                    })} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        allusers: selectors.allUsers(state),
        labels: uistate.selectors.uiLabels(state),
    };
}

export default connect(mapStateToProps,
    {
        loadUsers,
        setSelectedUser
    })(UsersTable);  